"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorTag = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".cdc2e8229{display:flex;align-items:center;flex-wrap:wrap;grid-gap:.9375rem}.c2210e0b3{border-radius:50%;height:1.5rem;width:1.5rem;display:flex;align-items:center;justify-content:center;border:.0625rem solid transparent}.c2210e0b3:last-child{margin-right:0}.cfb98a48a{border-color:var(--color-flomni-gray-90);box-shadow:0 0 .3125rem rgba(79,79,79,.5)}.c7a683682{border-radius:50%;height:1.25rem;width:1.25rem;cursor:pointer;box-shadow:0 .0625rem .125rem rgba(0,0,0,.15)}");
var styles = {
  root: 'cdc2e8229',
  option: 'c2210e0b3',
  '--selected': 'cfb98a48a',
  color: 'c7a683682'
};

var ColorTag = function ColorTag(props) {
  var colors = props.colors,
      color = props.color,
      onChange = props.onChange,
      classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var onChangeHandlers = (0, _react.useMemo)(function () {
    return colors.map(function (item) {
      return function () {
        return onChange(item);
      };
    });
  }, [colors, onChange]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, colors.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: (0, _classnames.default)(cn.option, (0, _defineProperty2.default)({}, cn.selected, color === item))
    }, /*#__PURE__*/_react.default.createElement("div", {
      onClick: onChangeHandlers[index],
      style: {
        backgroundColor: item
      },
      className: cn.color
    }));
  }));
};

exports.ColorTag = ColorTag;
ColorTag.propTypes = {
  /* component logic props */
  colors: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  color: _propTypes.string.isRequired,
  onChange: _propTypes.func.isRequired,

  /* styling modificators */

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
ColorTag.defaultProps = {
  classes: {}
};